export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validatePassword = (password) => {
  return password ? true : false;
};

export const getCurrentYear = () => {
  try {
    const year = new Date().getFullYear();
    if (year >= 2020 && year <= 2100) {
      return year;
    }
    return 2026;
  } catch (error) {
    return 2026;
  }
};
